<template>
  <MainLayout>
    <b-row id="stichwortSelector">
      <b-col
        class="shadow-sm"
        style
      >
        <h4
          class="card-title font-weight-bold"
          style="margin-bottom: 40px"
        >
          Stichwortverwaltung
        </h4>

        <b-card-body>
          <b-row>
            <u-error-handling
              v-if="errorObject"
              :error-object="errorObject"
            />
            <b-col
              cols="4"
              class="mb-4"
            >
              <keyword-search-select-list
                ref="searchSelectList"
                class="searchSelectList"
                :all-list-items="allKeyWords"
                property-to-display="code"
                :property-to-search="['code']"
              />
            </b-col>

            <keywords-edit
              @keyword-added="keywordAdded"
              @keyword-updated="keywordUpdated"
              @keyword-deleted="keywordDeleted"
            />
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
    <div style="height: 500px" />
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import KeywordSearchSelectList from "@/components/keywords/KeywordSearchSelectList.vue";
import KeywordsEdit from "@/components/keywords/KeywordsEdit.vue";

export default {
  components: {
    MainLayout,
    KeywordSearchSelectList,
    KeywordsEdit,
  },
  data() {
    return {
      keywordId: null,
      editMode: false,
      newMode: false,
      allKeyWords: [],
      presetFilterText: "",
      errorObject: null,
      originalLanguages: ["de-CH", "fr-CH", "it-CH"],
    };
  },

  created() {},

  methods: {
    keywordAdded(keyword) {
      this.$router.push({ path: `/keywords/${keyword.id}` });
      this.$refs.searchSelectList.reloadAllKeyWords();
      this.presetFilterText = keyword.code;
    },

    keywordUpdated(keyword) {
      this.$router.push({ path: `/keywords/${keyword.id}` });
      this.$refs.searchSelectList.reloadAllKeyWords();
    },

    keywordDeleted() {
      this.$router.push({ path: "/keywords" });
      this.$refs.searchSelectList.reloadAllKeyWords();
    },
  },
};
</script>

<style scoped>
#stichwortSelector .v-list__tile--link {
  padding: 9px;
}

#stichwortSelector .v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.keyWordPropertyListItem {
  list-style-position: inside;
}

.viewModeValue {
  font-size: initial;
}

.searchSelectList {
  height: 600px;
}

.loadingGif {
  height: 200px;
  width: 200px;
  position: relative;
  left: 25%;
}

.mutliselectSelectionItem {
  padding: 4px 11px;
  background-color: rgb(0, 140, 255);
  color: white;
  border-radius: 5px;
}

.mutliselectSelectionItem i {
  margin-left: 5px;
  font-size: 14px;
}

.anchorForMultiselect {
  width: 100%;
  height: 1px;
  position: relative;
  top: 0px;
}
</style>
